import React, { useEffect, useMemo, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../firebase";
import Sidebar from "../components/Sidebar";

export default function AdminMaintenance() {
  const [appointments, setAppointments] = useState([]);
  const [search, setSearch] = useState("");
  const [statut, setStatut] = useState("");

  const loadAppointments = async () => {
    try {
      const q = query(
        collection(db, "maintenance_appointments"),
        orderBy("createdAt", "desc")
      );
      const snap = await getDocs(q);
      const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setAppointments(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadAppointments();
  }, []);

  const filteredAppointments = useMemo(() => {
    return appointments.filter((item) => {
      const text =
        `${item.nom || ""} ${item.marque || ""} ${item.modele || ""} ${item.service || ""}`.toLowerCase();

      return (
        (!search || text.includes(search.toLowerCase())) &&
        (!statut || item.statut === statut)
      );
    });
  }, [appointments, search, statut]);

  const updateStatus = async (id, newStatus) => {
    try {
      await updateDoc(doc(db, "maintenance_appointments", id), {
        statut: newStatus,
      });

      setAppointments((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, statut: newStatus } : item
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="d-flex flex-column flex-md-row">
      <Sidebar />

      <main className="flex-grow-1 p-4" style={{ marginLeft: "250px" }}>
        <div className="container-fluid">
          <div className="mb-4">
            <h2 className="fw-bold mb-1">Rendez-vous maintenance</h2>
            <p className="text-muted mb-0">
              Gérez les demandes de maintenance envoyées par les visiteurs.
            </p>
          </div>

          <div className="row g-3 mb-4">
            <div className="col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="Rechercher par nom, marque, modèle ou service..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <select
                className="form-select"
                value={statut}
                onChange={(e) => setStatut(e.target.value)}
              >
                <option value="">Tous les statuts</option>
                <option value="en attente">En attente</option>
                <option value="confirmé">Confirmé</option>
                <option value="terminé">Terminé</option>
                <option value="annulé">Annulé</option>
              </select>
            </div>
          </div>

          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead>
                    <tr>
                      <th>Client</th>
                      <th>Véhicule</th>
                      <th>Service</th>
                      <th>Date souhaitée</th>
                      <th>Statut</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAppointments.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <div className="fw-semibold">{item.nom}</div>
                          <small className="text-muted">{item.telephone}</small>
                        </td>
                        <td>
                          {item.marque} {item.modele}
                          <br />
                          <small className="text-muted">
                            {item.immatriculation || "Sans immatriculation"}
                          </small>
                        </td>
                        <td>{item.service}</td>
                        <td>{item.dateSouhaitee || "—"}</td>
                        <td>
                          <span
                            className={`badge ${
                              item.statut === "confirmé"
                                ? "bg-success"
                                : item.statut === "annulé"
                                ? "bg-danger"
                                : item.statut === "terminé"
                                ? "bg-primary"
                                : "bg-warning text-dark"
                            }`}
                          >
                            {item.statut}
                          </span>
                        </td>
                        <td>
                          <select
                            className="form-select form-select-sm"
                            value={item.statut}
                            onChange={(e) => updateStatus(item.id, e.target.value)}
                          >
                            <option value="en attente">En attente</option>
                            <option value="confirmé">Confirmé</option>
                            <option value="terminé">Terminé</option>
                            <option value="annulé">Annulé</option>
                          </select>
                        </td>
                      </tr>
                    ))}

                    {filteredAppointments.length === 0 && (
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-4">
                          Aucun rendez-vous trouvé.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
